import { gql } from '@apollo/client'
import { countryFragment } from '~/graphql/fragments/country'

export const locationResultFragment = gql`
  fragment locationResult on LocationResult {
    id
    slug
    name
    cityName
    country {
      ...country
    }
  }

  ${countryFragment}
`
